import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import AdminDashboard from './components/admin/AdminDashboard';
import UserDashboard from './components/user/UserDashboard';
import Login from './components/auth/Login';
import MainInterface from './components/main/MainInterface';
import { User } from './types';

const theme = createTheme();

const App: React.FC = () => {
    const [user, setUser] = useState<User | null>(null);

    useEffect(() => {
        const storedUser = localStorage.getItem('user');
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    const handleLogin = (userData: User) => {
        setUser(userData);
        localStorage.setItem('user', JSON.stringify(userData));
    };

    const handleLogout = () => {
        setUser(null);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
    };

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <Routes>
                    <Route path="/" element={<MainInterface />} />
                    <Route path="/j8n5x2v4l9q7" element={
                        user?.role === 'admin' ? (
                            <AdminDashboard onLogout={handleLogout} />
                        ) : (
                            <Navigate to="/j8n5x2v4l9q7/login" replace />
                        )
                    } />
                    <Route path="/j8n5x2v4l9q7/login" element={
                        user?.role === 'admin' ? (
                            <Navigate to="/j8n5x2v4l9q7" replace />
                        ) : (
                            <Login onLogin={handleLogin} defaultMode="admin" />
                        )
                    } />
                    <Route path="/user/login" element={
                        user?.role === 'user' ? (
                            <Navigate to="/dashboard" replace />
                        ) : (
                            <Login onLogin={handleLogin} defaultMode="user" />
                        )
                    } />
                    <Route path="/dashboard" element={
                        user?.role === 'user' ? (
                            <UserDashboard onLogout={handleLogout} />
                        ) : (
                            <Navigate to="/user/login" replace />
                        )
                    } />
                    <Route path="/login" element={<Navigate to="/user/login" replace />} />
                </Routes>
            </Router>
        </ThemeProvider>
    );
};

export default App;
